module.exports = __webpack_public_path__ + "img/06.886dfbe0.png";